import { createSlice } from "@reduxjs/toolkit";

const emptyFilterOption = { id: null, name: "" };

const normalizeFilterOption = (value) => {
  if (!value || typeof value !== "object") {
    return emptyFilterOption;
  }

  return {
    id: value.id ?? null,
    name: value.name ?? "",
  };
};

export const projectsPageSlice = createSlice({
  name: "projectsPageState",
  initialState: {
    filters: {
      page: 1,
      sortFilter: "id",
      sortAscending: true,
      searchWord: "",
      statusFilter: {"id": null, "name": ""},
      tagFilter: {"id": null, "name": ""},
      hideArchived: true,
    },
    projectsList: [],
    typesList: [],
  },
  reducers: {
    updateFilters: (state, action) => {
      const incomingFilters = action.payload || {};

      state.filters = {
        ...state.filters,
        ...incomingFilters,
        statusFilter: normalizeFilterOption(incomingFilters.statusFilter ?? state.filters.statusFilter),
        tagFilter: normalizeFilterOption(incomingFilters.tagFilter ?? state.filters.tagFilter),
      };
    },
    updateProjectsList: (state, action) => {
      const projectsList = action.payload;
    
      // Check if projectsList is an array
      if (Array.isArray(projectsList)) {
        state.projectsList = projectsList;
      } else {
        state.projectsList = []; // Set to an empty array if not an array
      }
    },
    resetStateProjectsPage: (state) => {
      state.filters = {
        page: 1,
        sortFilter: "id",
        sortAscending: true,
        searchWord: "",
        statusFilter: {"id": null, "name": ""},
        tagFilter: {"id": null, "name": ""},
        hideArchived: true,
      }
      state.projectsList = []
    },
    updateTypesList: (state, action) => {
      state.typesList = action.payload;
    },
  },
})

export const { updateFilters, updateProjectsList, resetStateProjectsPage, updateTypesList } = projectsPageSlice.actions
export default projectsPageSlice.reducer
